import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaFormFieldComponent } from '../fields/textarea-form-field/textarea-form-field.component';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { DropdownEntryEnum, DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { take } from 'rxjs';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';
import { HelperService } from 'app/shared/services/helper.service';
import { CaseFormModel } from 'app/case-form/case-form.model';

@Component({
  selector: 'app-process-details-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextareaFormFieldComponent,
    SelectFormFieldComponent,
    TranslateModule,
    ConfigurationSelectFormFieldComponent
  ],
  templateUrl: './process-details-form.component.html',
  styleUrl: './process-details-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ProcessDetailsFormComponent {
  @Input() viewMode!: boolean;
  @Input() case!: CaseFormModel;
  toolItems: any[] = [];
  chamberItems: any[] = [];

  form: any;
  toolManufacturerItems: any[] = [];
  dropdownTypeEnum = DropdownTypeEnum;
  dropdownType = DropdownTypeEnum.PROCESS_INFORMATION;
  dropdownProcessType = DropdownTypeEnum.PROCESS_TYPE;
  entry1 = DropdownEntryEnum.ENTRY_1;
  entry2 = DropdownEntryEnum.ENTRY_2;
  entry3 = DropdownEntryEnum.ENTRY_3;

  constructor(
    public mainForm: FormGroupDirective,
    private configurationService: ConfigurationService,
    private helperService: HelperService,
  ) { }

  ngOnChanges() {
    if (this.case) {
      this.helperService.enableDisableDependentFieldOnSelect(this.form, this.case.toolManufacturer, 'tool');
      this.helperService.enableDisableDependentFieldOnSelect(this.form, this.case.tool, 'chamber');
    }
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('toolManufacturer', new FormControl(null, []));
    this.form.addControl('tool', new FormControl({ value: null, disabled: !this.viewMode }, []));
    this.form.addControl('chamber', new FormControl({ value: null, disabled: !this.viewMode }, []));
    this.form.addControl('processType', new FormControl(null, []));
    this.form.addControl('additionalProcessInfo', new FormControl(null, []));
  }

  onSelectToolFields(data: any, field: string) {
    this.resetToolFields(field, data);

    if (!data) {
      return;
    }

    let params = {
      type: this.dropdownType,
      entry1: this.form.get('toolManufacturer')?.value || '',
      entry2: this.form.get('tool')?.value || '',
      entry3: this.form.get('chamber')?.value || '',
    };

    if (!params.entry1) {
      return;
    }

    let entry = this.entry2;

    if (field === DropdownTypeEnum.CHAMBER) {
      if (!params.entry2) {
        return;
      }
      entry = this.entry3;
    }

    this.configurationService.getDropdownConfigurations(params, entry)
      .pipe(take(1))
      .subscribe((res: any) => {
        switch (field) {
          case DropdownTypeEnum.TOOL:
            this.toolItems = res;
            break;
          case DropdownTypeEnum.CHAMBER:
            this.chamberItems = res;
            break;
        }
      });

  }

  resetToolFields(resetField: string, data: any) {
    if (resetField === DropdownTypeEnum.TOOL) {
      this.form.get('tool').setValue(null);
      this.toolItems = [];
      this.helperService.enableDisableDependentFieldOnSelect(this.form, data, 'tool');

      this.resetToolFields(DropdownTypeEnum.CHAMBER, null);
    }


    if (resetField === DropdownTypeEnum.CHAMBER) {
      this.form.get('chamber').setValue(null);
      this.chamberItems = [];
      this.helperService.enableDisableDependentFieldOnSelect(this.form, data, 'chamber');
    }
  }

}
